module.exports = __webpack_public_path__ + "static/media/PeriodonticsSyllabus.ddcb2854.docx";